<template>
    <div class="page">
        <img class="top" src="~@/assets/help-top.png" alt="" />
        <div class="notice">
            <div>联系客服</div>
            <div v-html="kefu"></div>
        </div>
        <div class="textarea-box">
            <img
                class="help-textarea"
                src="~@//assets/help-textarea.png"
                alt=""
            />
            <textarea
                class="content"
                placeholder="长按识别下方二维码添加客服微信，提出您的宝贵意见"
                v-model="content"
            ></textarea>
        </div>
        <div class="footer">
            <img class="help-qrcode" :src="kefuQr" alt="" />
            <div class="btn" @click="submit()">提交</div>
        </div>
    </div>
</template>

<script>
    import userCenterService from "../../service/user-center.service";
    import { Toast } from "vant";
    export default {
        name: "help",
        data() {
            return {
                content: "",
                kefu: "",
                kefuQr: "",
                loading: false,
            };
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                userCenterService.getOtherInfo().then((res) => {
                    this.kefu = res.data.kefu;
                    this.kefuQr = res.data.kefuQr;
                });
            },
            submit() {
                if (this.loading) {
                    Toast("提交中。。。");
                    return;
                }
                this.loading = true;
                userCenterService
                    .feedback({ content: this.content })
                    .then(() => {
                        Toast("提交成功");
                        this.$router.push({ path: `/user-center` });
                        this.setTimeout(() => {
                            this.loading = false;
                        }, 60000);
                    })
                    .catch(() => {
                        Toast("提交失败");
                        this.loading = false;
                    });
            },
        },
    };
</script>

<style lang="scss" scoped src="./help.scss"></style>
